import { createContext, useContext, useState } from "react";

const MobileNavContext = createContext({
  mobileOpen: false,
  toggleMobileNav: () => {},
  closeMobileNav: () => {},
});

export const MobileNavProvider = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <MobileNavContext.Provider
      value={{
        mobileOpen,
        toggleMobileNav: () => setMobileOpen((prev) => !prev),
        closeMobileNav: () => setMobileOpen(false),
      }}
    >
      {children}
    </MobileNavContext.Provider>
  );
};

export const useMobileNav = () => useContext(MobileNavContext);
